export class CreacionCodigos {
    public cantidad: number;
    public codigoSede: string;
    public nombreSede: string;
}